import request from '@/utils/request'
import qs from 'qs'
/*
  系统管理-区域管理 权限操作api
*/

// 查询区域列表树
export function getAreaTreeList(data) {
  return request({
    url: 'user-service/area/getAreaTreeList',
    method: 'get',
    params: data
  })
}


// 查询所有区域树
export function getDepartmentList(data) {
  return request({
    url: 'user-service/dept/getDeptTreeList',
    method: 'get',
    params: data
  })
}

// 查询本级节点ID-直系子级节点
export function getDeptSubByDeptId(data) {
  return request({
    url: 'user-service/dept/getDeptSubByDeptId',
    method: 'get',
    params: data
  })
}

// 查询区域列表
export function getDeptTreeByDeptId(data) {
  return request({
    url: 'user-service/dept/getDeptTreeByDeptId',
    method: 'get',
    params: data
  })
}
// 修改
export function editSubmitApi(formData) {
  const data = qs.stringify(formData)
  return request({
    url: 'user-service/dept/updateDept',
    method: 'post',
    data
  })
}

// 新增
export function addSubmitApi(formData) {
  const data = qs.stringify(formData)
  return request({
    url: 'user-service/dept/saveDept',
    method: 'post',
    data
  })
}

// 删除
export function delSubmitApi(formData) {
  return request({
    headers: {
      'Content-Type': 'application/json'
    },
    url: 'user-service/dept/removeDept',
    method: 'get',

    params: formData
  })
}
